<div class="flex-faqs">
    <h2 class="flex-faqs__header" [innerHTML]="block.data.header"></h2>

    <section class="flex-faqs__section" *ngFor="let item of block.content trackBy: trackByFn;">
        <h3 class="flex-faqs__section-header" [innerHTML]="item.data.sectionHeader"></h3>
        <div
            class="flex-faqs__section-content" 
            [ngClass]="{
                container: block.data.columnsSmall == 'full' ||  block.data.columnsNormal == 'full',
                'col-sm-12': block.data.columnsSmall == 'full',
                'col-md-12': block.data.columnsNormal == 'full'
            }"
        >
            <core-block
                *ngFor="let subBlock of item.content"
                [block]="subBlock"
                class="subWidget {{subBlock.data.class}}"
            >
            </core-block>
        </div>
    </section>
</div>
